import { constants } from './constants';
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory("auth");

export const SetIsAuthAction = actionCreator<boolean>(constants.SET_IS_AUTH_ACTION);
